import { createFileRoute } from "@tanstack/react-router";
import { Pricing } from "./priser";

export const Route = createFileRoute("/en/pricing")({
  head: () => ({
    meta: [
      { title: "Pricing – free, Plus and Pro plans | Sellavo" },
      { name: "description", content: "Start free with 5 listings a month, or upgrade to Plus or Pro for more." },
      { property: "og:title", content: "Pricing – free, Plus and Pro plans | Sellavo" },
      { property: "og:description", content: "Start free with 5 listings a month, or upgrade to Plus or Pro for more." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/pricing" }],
  }),
  component: Pricing,
});
